module.exports = __webpack_public_path__ + "static/media/tournament-tickets-active-icon.d2ed25a8.svg";